import { ref } from '@vue/composition-api';

const deploying = ref(false);

export default function useDeploy() {
  return {
    deploying,
  };
}
